import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OwnerProfileComponent } from '../owner-profile/owner-profile.component';
import {Component, OnInit, ViewChild} from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OwnerProfile } from '../owner-profile';
import { OwnerProfileService } from '../owner-profile.service';
import {Contact} from '@app/_components/contact';
import {ImportExportComponent} from '@app/_components/_helpers/import-export/import-export.component';
import {Location} from "@angular/common";

@Component({
    selector: 'app-owner-profile-list',
    templateUrl: './owner-profile-list.component.html',
    styleUrls: ['./owner-profile-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OwnerProfileListComponent implements OnInit {
	propertyCodes: any;
	propertyNames: any;
	sampleLink = 'https://s3.us-east-1.amazonaws.com/img.kbmblog.com/import_owner_profile_sample.xlsx';
	@ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
	satisfactionRanks: any[]=[];
	constructor(
		private ownerProfileService: OwnerProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private location1: Location,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.listingStatuses = ownerProfileService.listingStatuses;
		this.satisfactionRanks = ownerProfileService.satisfactionRanks;
	}


	// data
	ownerProfiles: any;
	ownerProfilesAll: any;
	ownerProfile: OwnerProfile;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	listingStatuses: any;
	
	columns: any[] = [
		{field: 'listingStatus', header: 'Status', width: 'auto'},
		{field: 'firstName', header: 'First Name', width: 'auto'},
		{field: 'lastName', header: 'Last Name', width: 'auto'},
		{field: 'emailAddress', header: 'Email Address', width: 'auto'},
		{field: 'mobilePhone', header: 'Mobile Phone', width: 'auto'},
		{field: 'spouseFirstName', header: 'Spouse First Name', width: 'auto'},
		{field: 'spouseLastName', header: 'Spouse Last Name', width: 'auto'},
		{field: 'spouseEmailAdress', header: 'Spouse Email Address', width: 'auto'},
		{field: 'propertyName', header: 'Property Name', width: 'auto'},
		{field: 'propertyCode', header: 'Property Code', width: 'auto'},
		{field: 'compHostNights', header: 'Influencer', width: 'auto'},
		{field: 'satisfactionRank', header: 'Satisfaction Rank', width: 'auto'},
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({field: 'createDate', order: 0});
		} catch (error) {
			console.log('Error: ' + error);
		}
	}

	getFilteredTags(tags) {
		//if filter text input is empty then load all records
		if (tags == '0') {
			delete this.lazyLoadEvent.filters.ownerProfileId;
			this.loadLazy(this.lazyLoadEvent);
		} else {
			//If records found then show filtered records
			if (tags.length > 0) {
				//if filter text input is not empty then load filtered records only
				var filteredIds = [];
				tags.forEach(tag => {
					filteredIds.push(tag.tagSourceId);
				});
				let activityProviderIdFilter = {'ownerProfileId': {'value': filteredIds, 'matchMode': 'in'}};
				Object.assign(this.lazyLoadEvent.filters, activityProviderIdFilter);
				this.loadLazy(this.lazyLoadEvent);
			} else {
				//Display empty table as no record found with filtered input
				this.ownerProfiles = [];
			}
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.ownerProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000});
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ownerProfile-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({field: 'createDate', order: -1});
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerProfileService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(
				(res: any) => {
					console.log("fffffffffff :" + JSON.stringify(res));
					this.datasource = res.data.reviews;
					this.recordTotal = res.page.recordTotal;
					this.ownerProfiles = res.data.ownerProfiles;
					console.log(JSON.stringify(res.page));
				},
				(err: any) => {
					console.log('reviews list error!: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => {
					this.loading = false;
				}
			);

			if (this.datasource) {
				this.ownerProfiles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazyForExport(exporttype: string) {
		let event = this.lazyLoadEvent;
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ownerProfile-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			event.rows = 1000;
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({field: 'createDate', order: -1});
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerProfileService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(
				(res: any) => {
					console.log("fffffffffff :" + JSON.stringify(res));
					this.ownerProfilesAll = res.data.ownerProfiles;
					this.importExportComponent.exporData(exporttype, this.ownerProfilesAll, 'Owner Profiles');
				},
				(err: any) => {
					console.log('reviews list error!: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => {
					this.loading = false;
				}
			);

			if (this.datasource) {
				this.ownerProfiles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() {
	}


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(ownerProfile: OwnerProfile) {
		try {
			this.formLoading = true;
			this.ownerProfileService.update(ownerProfile)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ownerProfiles.map((ownerProfile, i) => {
							if (ownerProfile.ownerProfileId === res.data.ownerProfile.ownerProfileId) {
								this.ownerProfiles[i] = res.data.ownerProfile;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({severity: 'success', summary: 'Success', detail: res.message});
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({severity: 'error', summary: JSON.stringify(err), life: 3000});
					},
					() => {
						this.formLoading = false;
					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(ownerProfile: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(ownerProfile));

			this.formLoading = true;
			this.ownerProfileService.delete(ownerProfile.ownerProfileId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ownerProfiles.splice(this.ownerProfiles.indexOf(ownerProfile), 1);
						this.recordTotal = this.ownerProfiles.length;
						this.messageService.add({severity: 'success', summary: 'Successful', detail: 'OwnerProfile ' + ownerProfile.ownerProfileId + ' Deleted', life: 3000});
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({severity: 'error', summary: 'Delete Failed', detail: 'OwnerProfile ' + ownerProfile.ownerProfileId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000});
					},
					() => {
						this.formLoading = false;
					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * Add New Button
	 *
	 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OwnerProfile',
			isDisplayPropertyProfile: false
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.addOwnerProfileCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
	 * Edit Button
	 *
	 */
	onOpenFormEdit(ownerProfile: OwnerProfile) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerProfile: ownerProfile,
			title: 'Edit OwnerProfile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerProfileComponent, dialogConfig);
		this.location1.go('/owner-profile/' + ownerProfile?.ownerProfileId);
		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.location1.go('/owner-profile-list');
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.updateOwnerProfileCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOwnerProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		// Used for updating the Portal access value
		dialogRef.componentInstance.doUpdateAccess.subscribe(
			data => {
				console.log('Dialog output:', data);

				//this.messageService.add({ severity: 'success', summary: 'Success', detail: "Processed Successfully." });

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.updateOwnerProfileCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				//	dialogRef.close();
			});
	}


	/**
	 *
	 * Dialog from Form Callbacks
	 * To edit the list show add/edit/delete in real time from the popup form
	 *
	 */
	addOwnerProfileCB(ownerProfile: OwnerProfile) {
		console.log('Adding OwnerProfile: ' + JSON.stringify(ownerProfile));
		// if we don't have a ownerProfiles array yet...
		if (!this.ownerProfiles) {
			this.ownerProfiles = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ownerProfiles.unshift(ownerProfile);

		// no idea what this is but it is required to update the array
		this.ownerProfiles = [...this.ownerProfiles];

		this.messageService.add({severity: 'success', summary: 'Success', detail: 'OwnerProfile ' + ownerProfile.ownerProfileId + ' Added', life: 3000});
	}

	updateOwnerProfileCB(ownerProfile: OwnerProfile) {
		console.log('Updating OwnerProfile: ' + JSON.stringify(ownerProfile));
		let itemIndex = this.ownerProfiles.findIndex((item: any) => item.ownerProfileId === ownerProfile.ownerProfileId);
		this.ownerProfiles[itemIndex] = ownerProfile;

		// no idea what this is but it is required to update the array
		this.ownerProfiles = [...this.ownerProfiles];

		this.messageService.add({severity: 'success', summary: 'Success', detail: 'OwnerProfile ' + ownerProfile.ownerProfileId + ' Updated', life: 3000});
	}

	deleteOwnerProfileCB(ownerProfile: OwnerProfile) {
		console.log('Removing OwnerProfile: ' + ownerProfile);
		this.ownerProfiles.splice(this.ownerProfiles.indexOf(ownerProfile), 1);
		this.recordTotal = this.ownerProfiles.length;

		// no idea what this is but it is required to update the array
		this.ownerProfiles = [...this.ownerProfiles];

		this.messageService.add({severity: 'success', summary: 'Success', detail: 'OwnerProfile ' + ownerProfile.ownerProfileId + ' Deleted', life: 3000});
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() {
		this.first = this.first + this.rows;
	}

	prev() {
		this.first = this.first - this.rows;
	}

	reset() {
		this.first = 0;
	}

	isLastPage(): boolean {
		return this.ownerProfiles ? this.first === (this.ownerProfiles.length - this.rows) : true;
	}

	isFirstPage(): boolean {
		return this.ownerProfiles ? this.first === 0 : true;
	}

	get Statuses() {
		return this.listingStatuses;
	}

	getStatusName(ownerProfile: any) {
		if (ownerProfile?.listingStatus) {
			const status = this.listingStatuses.find((e: any) => e.value == ownerProfile.listingStatus);
			return status?.name;
		} else {
			return '';
		}
	}

	getSatisfactionRankName(ownerProfile: any) {
		if (ownerProfile?.satisfactionRank != undefined && ownerProfile?.satisfactionRank != null && ownerProfile?.satisfactionRank != "") {
			const status = this.satisfactionRanks.find((e: any) => e.value == ownerProfile.satisfactionRank);
			return status?.name;
		} else {
			return '';
		}
	}

	getPropertyCode(ownerProfiles: any) {
		this.propertyCodes = "";
		var count = 0;
		ownerProfiles.forEach(ownerProfile => {
			if (count == 0) {
				this.propertyCodes = ownerProfile.propertyCode;
				count = count + 1;
			} else {
				this.propertyCodes = this.propertyCodes + ", " + ownerProfile.propertyCode;
			}

		});
		return this.propertyCodes;
	}

	getPropertyName(ownerProfiles: any) {
		this.propertyNames = "";
		var count = 0;
		ownerProfiles.forEach(ownerProfile => {
			if (count == 0) {
				this.propertyNames = ownerProfile.propertyName;
				count = count + 1;
			} else {
				this.propertyNames = this.propertyNames + ", " + ownerProfile.propertyName;
			}

		});
		return this.propertyNames;
	}

	reloadPage() {
		window.location.reload();
	}

	dataAndTagSelected($event: any) {
		let data = $event.jsonArrayRaw;
		let tagsSelected = $event.tagJoinAPIList;
		let ownerProfiles = [];
		data.forEach(json => {
			try {
				const profile = new OwnerProfile();
				profile.emailAddress = json.emailAddress;
				profile.fullName = json.fullName;
				profile.firstName = json.firstName;
				profile.lastName = json.lastName;
				profile.subjAdrStreet = json.subjAdrStreet;
				profile.mobilePhone = json.mobilePhone;
				profile.phone2 = json.phone2;
				profile.mailAdrStreet = json.mailAdrStreet;
				profile.mailAdrStreet2 = json.mailAdrStreet2;
				profile.mailAdrCity = json.mailAdrCity;
				profile.mailAdrState = json.mailAdrState;
				profile.mailAdrCountry = json.mailAdrCountry;
				profile.mailAdrPostalCode = json.mailAdrPostalCode;
				ownerProfiles.push(profile);
			} catch (e) {
			}
		});
		let postingData = {
			tagJoinAPIList: tagsSelected,
			ownerProfileAPIList: ownerProfiles
		};
		this.ownerProfileService.importOwnerProfile(postingData)
			.subscribe(
				(res: any) => {
					console.log('property-add SUCCESS: ' + JSON.stringify(res));
					this.messageService.add({severity: 'success', summary: 'Success', detail: 'EMployee Profiles imported successful'});
					this.loadLazy(this.lazyLoadEvent);
				},
				(err: any) => {
					console.log('importContact-add FAIL: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => {
					this.formLoading = false;
				});
	}

	exportSelected(exporttype: any) {
    this.importExportComponent.exporData(exporttype, this.ownerProfiles, 'Owner Profiles');
	}
}
